module.exports = __webpack_public_path__ + "img/-LV194q5IFaVI0BOkURK.0147e2ae.jpg";